import ProfileInfo from 'containers/worker/profile-stages/basic-info';
import WorkerAddress from 'containers/worker/profile-stages/worker-address';
import ConfirmWorkerAddress from 'containers/worker/profile-stages/confirm-worker-address';
import OfficialDocuments from 'containers/worker/profile-stages/official-documents';
import JobRoles from 'containers/worker/profile-stages/job-roles';
import Courses from 'containers/worker/profile-stages/courses';
import Experience from 'containers/worker/profile-stages/experience';
import References from 'containers/worker/profile-stages/references';
import Covid from 'containers/worker/profile-stages/covid';

export const defaultStage = {
  title: 'Pending',
  description: 'Pending',
  status: undefined,
  disabled: true,
  component: undefined,
};

const Stages = [
  ProfileInfo,
  OfficialDocuments,
  WorkerAddress,
  ConfirmWorkerAddress,
  JobRoles,
  Courses,
  Experience,
  References,
  Covid,
].map((stage) => ({
  ...stage,
  disabled: false,
}));

export default Stages;
